import React, { useState } from 'react';
import { Users, Calendar, CheckSquare, FileText, Clock, ChevronLeft, ArrowLeft } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
export function SubCommitteeDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const subCommitteeId = parseInt(id || '101');
  const parentCommitteeId = Math.floor(subCommitteeId / 100);
  const [activeTab, setActiveTab] = useState('overview');
  // Mock sub-committee data
  const subCommittee = {
    id: subCommitteeId,
    name: subCommitteeId === 101 ? 'فريق حوكمة مجلس الإدارة' : subCommitteeId === 102 ? 'فريق الامتثال التنظيمي' : subCommitteeId === 103 ? 'فريق علاقات المساهمين' : 'فريق',
    parentId: parentCommitteeId,
    parentName: parentCommitteeId === 1 ? 'لجنة الحوكمة' : parentCommitteeId === 2 ? 'اللجنة التنفيذية' : parentCommitteeId === 3 ? 'لجنة التدقيق' : 'لجنة',
    description: 'هذا الفريق مسؤول عن جوانب محددة من الحوكمة ضمن هيكل اللجنة الأم.',
    members: [{
      id: 1,
      name: 'محمد الهاشمي',
      role: 'رئيس الفريق',
      department: 'المالية',
      avatar: 'م'
    }, {
      id: 2,
      name: 'عائشة المنصوري',
      role: 'منسق',
      department: 'المالية',
      avatar: 'ع'
    }, {
      id: 3,
      name: 'عمر الشامسي',
      role: 'عضو',
      department: 'العمليات',
      avatar: 'ع'
    }],
    tasks: [{
      id: 1,
      title: 'مراجعة وثائق إطار الحوكمة',
      status: 'completed',
      dueDate: '2023-09-15'
    }, {
      id: 2,
      title: 'إعداد تقرير الامتثال الربع سنوي',
      status: 'pending',
      dueDate: '2023-10-10'
    }, {
      id: 3,
      title: 'إجراء جلسة تدريبية حول الحوكمة',
      status: 'pending',
      dueDate: '2023-09-30'
    }],
    meetings: [{
      id: 1,
      title: 'التنسيق الأسبوعي للفريق',
      date: '2023-09-15',
      time: '10:00 صباحاً',
      location: 'عبر الإنترنت'
    }, {
      id: 2,
      title: 'مراجعة إطار الحوكمة',
      date: '2023-09-28',
      time: '02:00 مساءً',
      location: 'قاعة المؤتمرات أ'
    }],
    documents: [{
      id: 1,
      name: 'ميثاق الفريق.pdf',
      type: 'PDF',
      uploadedDate: '2023-08-15'
    }, {
      id: 2,
      name: 'تقرير التقدم للربع الثاني.xlsx',
      type: 'XLSX',
      uploadedDate: '2023-07-20'
    }, {
      id: 3,
      name: 'إطار الحوكمة.docx',
      type: 'DOCX',
      uploadedDate: '2023-08-30'
    }],
    stats: {
      completionRate: 75,
      meetingsHeld: 8,
      documentsUploaded: 12,
      tasksCompleted: 24
    }
  };
  const getStatusClass = (status: string) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'pending':
        return 'bg-orange-100 text-orange-800';
      case 'delayed':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div dir="rtl" data-id="element-839">
      <div className="flex flex-col mb-6" data-id="element-840">
        <Link to={`/committees/${parentCommitteeId}`} className="flex items-center text-gray-600 hover:text-gray-900 mb-2" data-id="element-841">
          <ArrowLeft size={16} className="ml-1 transform rotate-180" data-id="element-842" />
          العودة إلى {subCommittee.parentName}
        </Link>
        <div className="flex items-center" data-id="element-843">
          <Link to="/committees" className="flex items-center text-gray-600 hover:text-gray-900 ml-4" data-id="element-844">
            <ChevronLeft size={20} className="ml-1 transform rotate-180" data-id="element-845" />
            جميع اللجان
          </Link>
          <h1 className="text-2xl font-bold" data-id="element-846">{subCommittee.name}</h1>
        </div>
        <div className="mt-1 text-sm text-gray-500" data-id="element-847">
          لجنة فرعية تابعة لـ{' '}
          <Link to={`/committees/${parentCommitteeId}`} className="text-orange-500 hover:underline" data-id="element-848">
            {subCommittee.parentName}
          </Link>
        </div>
      </div>
      {/* Tab Navigation */}
      <div className="bg-white rounded-lg shadow-sm mb-6" data-id="element-849">
        <div className="flex border-b border-gray-200" data-id="element-850">
          <button className={`px-4 py-3 font-medium ${activeTab === 'overview' ? 'text-orange-500 border-b-2 border-orange-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('overview')} data-id="element-851">
            نظرة عامة
          </button>
          <button className={`px-4 py-3 font-medium ${activeTab === 'members' ? 'text-orange-500 border-b-2 border-orange-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('members')} data-id="element-852">
            الأعضاء
          </button>
          <button className={`px-4 py-3 font-medium ${activeTab === 'tasks' ? 'text-orange-500 border-b-2 border-orange-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('tasks')} data-id="element-853">
            المهام
          </button>
          <button className={`px-4 py-3 font-medium ${activeTab === 'meetings' ? 'text-orange-500 border-b-2 border-orange-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('meetings')} data-id="element-854">
            الاجتماعات
          </button>
          <button className={`px-4 py-3 font-medium ${activeTab === 'documents' ? 'text-orange-500 border-b-2 border-orange-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('documents')} data-id="element-855">
            المستندات
          </button>
        </div>
      </div>
      {/* Overview Tab */}
      {activeTab === 'overview' && <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6" data-id="element-856">
          {/* Sub-Committee Info */}
          <div className="bg-white rounded-lg shadow-sm p-6 lg:col-span-2" data-id="element-857">
            <h2 className="text-lg font-semibold mb-4" data-id="element-858">معلومات الفريق</h2>
            <p className="text-gray-700 mb-4" data-id="element-859">{subCommittee.description}</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6" data-id="element-860">
              <div className="bg-blue-50 p-4 rounded-lg" data-id="element-861">
                <div className="flex items-center text-blue-500 mb-2" data-id="element-862">
                  <Users size={18} className="ml-2" data-id="element-863" />
                  <span className="font-medium" data-id="element-864">الأعضاء</span>
                </div>
                <p className="text-2xl font-bold" data-id="element-865">
                  {subCommittee.members.length}
                </p>
              </div>
              <div className="bg-green-50 p-4 rounded-lg" data-id="element-866">
                <div className="flex items-center text-green-500 mb-2" data-id="element-867">
                  <CheckSquare size={18} className="ml-2" data-id="element-868" />
                  <span className="font-medium" data-id="element-869">المهام</span>
                </div>
                <p className="text-2xl font-bold" data-id="element-870">
                  {subCommittee.tasks.length}
                </p>
              </div>
              <div className="bg-purple-50 p-4 rounded-lg" data-id="element-871">
                <div className="flex items-center text-purple-500 mb-2" data-id="element-872">
                  <Calendar size={18} className="ml-2" data-id="element-873" />
                  <span className="font-medium" data-id="element-874">الاجتماعات</span>
                </div>
                <p className="text-2xl font-bold" data-id="element-875">
                  {subCommittee.meetings.length}
                </p>
              </div>
              <div className="bg-orange-50 p-4 rounded-lg" data-id="element-876">
                <div className="flex items-center text-orange-500 mb-2" data-id="element-877">
                  <FileText size={18} className="ml-2" data-id="element-878" />
                  <span className="font-medium" data-id="element-879">المستندات</span>
                </div>
                <p className="text-2xl font-bold" data-id="element-880">
                  {subCommittee.documents.length}
                </p>
              </div>
            </div>
            <div className="mt-6" data-id="element-881">
              <h3 className="font-medium mb-2" data-id="element-882">تقدم الفريق</h3>
              <div className="w-full bg-gray-200 rounded-full h-2.5 mb-1" data-id="element-883">
                <div className="h-2.5 rounded-full bg-orange-500" style={{
              width: `${subCommittee.stats.completionRate}%`
            }} data-id="element-884"></div>
              </div>
              <div className="flex justify-between text-xs text-gray-500" data-id="element-885">
                <span data-id="element-886">نسبة الإنجاز الكلية</span>
                <span data-id="element-887">{subCommittee.stats.completionRate}%</span>
              </div>
            </div>
          </div>
          {/* Quick Actions */}
          <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-888">
            <h2 className="text-lg font-semibold mb-4" data-id="element-889">إجراءات سريعة</h2>
            <div className="space-y-3" data-id="element-890">
              <button className="w-full flex items-center justify-center p-3 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-891">
                <Calendar size={18} className="ml-2" data-id="element-892" />
                جدولة اجتماع
              </button>
              <button className="w-full flex items-center justify-center p-3 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-893">
                <CheckSquare size={18} className="ml-2" data-id="element-894" />
                إضافة مهمة
              </button>
              <button className="w-full flex items-center justify-center p-3 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-895">
                <FileText size={18} className="ml-2" data-id="element-896" />
                تحميل مستند
              </button>
              <button className="w-full flex items-center justify-center p-3 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-897">
                <Users size={18} className="ml-2" data-id="element-898" />
                إدارة الأعضاء
              </button>
              <Link to={`/committees/${subCommittee.id}/edit`} className="w-full flex items-center justify-center p-3 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors" data-id="element-899">
                تعديل تفاصيل الفريق
              </Link>
            </div>
          </div>
        </div>}
      {/* Members Tab */}
      {activeTab === 'members' && <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-900">
          <div className="flex justify-between items-center mb-4" data-id="element-901">
            <h2 className="text-lg font-semibold" data-id="element-902">أعضاء الفريق</h2>
            <button className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-903">
              إضافة عضو
            </button>
          </div>
          <div className="overflow-x-auto" data-id="element-904">
            <table className="w-full" data-id="element-905">
              <thead data-id="element-906">
                <tr className="bg-gray-50" data-id="element-907">
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-908">
                    العضو
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-909">
                    الدور
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-910">
                    القسم
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-911">
                    الإجراءات
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-912">
                {subCommittee.members.map(member => <tr key={member.id} data-id="element-913">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-914">
                      <div className="flex items-center" data-id="element-915">
                        <div className="h-8 w-8 bg-gray-700 rounded-full flex items-center justify-center text-white font-medium ml-3" data-id="element-916">
                          {member.avatar}
                        </div>
                        <span className="font-medium" data-id="element-917">{member.name}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-918">
                      <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${member.role === 'رئيس الفريق' ? 'bg-blue-100 text-blue-800' : member.role === 'منسق' ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-919">
                        {member.role}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-920">
                      {member.department}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-921">
                      <button className="text-orange-500 hover:text-orange-700 ml-3" data-id="element-922">
                        عرض
                      </button>
                      <button className="text-orange-500 hover:text-orange-700" data-id="element-923">
                        مراسلة
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}
      {/* Tasks Tab */}
      {activeTab === 'tasks' && <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-924">
          <div className="flex justify-between items-center mb-4" data-id="element-925">
            <h2 className="text-lg font-semibold" data-id="element-926">المهام</h2>
            <button className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-927">
              إضافة مهمة
            </button>
          </div>
          <div className="overflow-x-auto" data-id="element-928">
            <table className="w-full" data-id="element-929">
              <thead data-id="element-930">
                <tr className="bg-gray-50" data-id="element-931">
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-932">
                    المهمة
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-933">
                    تاريخ الاستحقاق
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-934">
                    الحالة
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-935">
                    الإجراءات
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-936">
                {subCommittee.tasks.map(task => <tr key={task.id} data-id="element-937">
                    <td className="px-6 py-4" data-id="element-938">
                      <div className="font-medium text-gray-900" data-id="element-939">
                        {task.title}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-940">
                      <div className="flex items-center" data-id="element-941">
                        <Calendar size={16} className="text-gray-500 ml-2" data-id="element-942" />
                        <span data-id="element-943">{task.dueDate}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-944">
                      <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusClass(task.status)}`} data-id="element-945">
                        {task.status === 'completed' ? 'مكتملة' : task.status === 'pending' ? 'معلقة' : task.status === 'delayed' ? 'متأخرة' : task.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-946">
                      <button className="text-orange-500 hover:text-orange-700 ml-3" data-id="element-947">
                        عرض
                      </button>
                      <button className="text-orange-500 hover:text-orange-700" data-id="element-948">
                        تعديل
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}
      {/* Meetings Tab */}
      {activeTab === 'meetings' && <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-949">
          <div className="flex justify-between items-center mb-4" data-id="element-950">
            <h2 className="text-lg font-semibold" data-id="element-951">الاجتماعات</h2>
            <button className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-952">
              جدولة اجتماع
            </button>
          </div>
          <div className="space-y-4" data-id="element-953">
            {subCommittee.meetings.map(meeting => <div key={meeting.id} className="border border-gray-200 rounded-lg p-4" data-id="element-954">
                <h3 className="font-medium mb-2" data-id="element-955">{meeting.title}</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-2" data-id="element-956">
                  <div className="flex items-center text-sm text-gray-500" data-id="element-957">
                    <Calendar size={16} className="text-gray-500 ml-2" data-id="element-958" />
                    <span data-id="element-959">{meeting.date}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-500" data-id="element-960">
                    <Clock size={16} className="text-gray-500 ml-2" data-id="element-961" />
                    <span data-id="element-962">{meeting.time}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-500" data-id="element-963">
                    <Users size={16} className="text-gray-500 ml-2" data-id="element-964" />
                    <span data-id="element-965">{meeting.location}</span>
                  </div>
                </div>
                <div className="mt-3 flex space-x-2" data-id="element-966">
                  <button className="px-3 py-1 bg-orange-500 text-white text-sm rounded-md hover:bg-orange-600 transition-colors" data-id="element-967">
                    عرض التفاصيل
                  </button>
                  <button className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded-md hover:bg-gray-300 transition-colors mr-2" data-id="element-968">
                    تعديل
                  </button>
                </div>
              </div>)}
          </div>
        </div>}
      {/* Documents Tab */}
      {activeTab === 'documents' && <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-969">
          <div className="flex justify-between items-center mb-4" data-id="element-970">
            <h2 className="text-lg font-semibold" data-id="element-971">المستندات</h2>
            <button className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-972">
              تحميل مستند
            </button>
          </div>
          <div className="overflow-x-auto" data-id="element-973">
            <table className="w-full" data-id="element-974">
              <thead data-id="element-975">
                <tr className="bg-gray-50" data-id="element-976">
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-977">
                    الاسم
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-978">
                    النوع
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-979">
                    تاريخ التحميل
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-980">
                    الإجراءات
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-981">
                {subCommittee.documents.map(document => <tr key={document.id} data-id="element-982">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-983">
                      <div className="font-medium text-gray-900" data-id="element-984">
                        {document.name}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-985">
                      <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${document.type === 'PDF' ? 'bg-red-100 text-red-800' : document.type === 'DOCX' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'}`} data-id="element-986">
                        {document.type}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-987">
                      {document.uploadedDate}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-988">
                      <button className="text-orange-500 hover:text-orange-700 ml-3" data-id="element-989">
                        عرض
                      </button>
                      <button className="text-orange-500 hover:text-orange-700 ml-3" data-id="element-990">
                        تنزيل
                      </button>
                      <button className="text-red-500 hover:text-red-700" data-id="element-991">
                        حذف
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}
    </div>;
}